import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root'
})
export class PageService {

	constructor(private api: ApiService) { }

	all() {
		return this.api.get('pages/all', { id: this.api.MERCHANT_ID });
	}
}
